import "./Middleinfo.css"
const Middleinfo = () => {
    return (
        <p className="middleinfo__text">
            132/11KV  VISHNU  SUBSTATION
        </p>
    );
};
export default Middleinfo;